import { useEffect, useState } from "react";
import { fetchNewspapers } from "../services/newspaperService";
import "../assets/css/news.css";
import { Link } from "react-router-dom";
import HeroSection from "../components/HeroSection";
import Seo from "../components/Seo";

const News = () => {
    const [newspapers, setNewspapers] = useState([]);

    useEffect(() => {
        fetchNewspapers().then(setNewspapers);
    }, []);

    return (
        <div className="newspaper-container-wrapper newspaper-page">
            <Seo
                title="News - Etawah e-Paper Archive"
                description="Etawah Times ई-पेपर आर्काइव - Etawah और Uttar Pradesh के सभी दैनिक अखबार एक जगह पढ़ें।"
                canonical="/news"
            />
            <HeroSection pageType="other" />
            <div className="container py-5">
                <h3 className="text-lg-center">News overview</h3>
                <div className="row">
                    {newspapers.map(news => (
                        <div className="col-lg-4 col-md-4 col-12 mb-3" key={news.id}>
                            <div className="card">
                                <Link className="newspaper-div" to={`/read/${news.slug}`}>
                                    <img src={news.image_url} className="card-img-top" alt={news.title} />
                                    <div className="card-body">
                                        <h5 className="mb-3">{news.title}</h5>
                                        <div className="d-flex justify-content-between">
                                            <p className="mb-0">{news.date}</p>
                                            <p className="mb-0">Read More</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

};

export default News;
